function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 9h-9a.5.5 0 01-.5-.5V5.832A5.13 5.13 0 018.953.743 5.009 5.009 0 0115 5.636V8.5a.5.5 0 01-.5.5zM6 8h8V5.793a4.104 4.104 0 00-3.163-4.071A4.007 4.007 0 006 5.636z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 24h-13A1.502 1.502 0 012 22.5v-13A1.502 1.502 0 013.5 8h13A1.502 1.502 0 0118 9.5V12a.5.5 0 01-1 0V9.5a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.501.501 0 00.5-.5V20a.5.5 0 011 0v2.5a1.502 1.502 0 01-1.5 1.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5 16.5h-16a.5.5 0 110-1h16a.5.5 0 110 1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 20.5a.498.498 0 01-.354-.146l-4-4a.5.5 0 010-.707l4-4a.5.5 0 11.707.707L8.207 16l3.647 3.647a.5.5 0 01-.354.854z"
});

function SvgSecurityGroup(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "securityGroup.7a1e6.svg";
export { SvgSecurityGroup as ReactComponent };